import { render } from "./Users.vue?vue&type=template&id=14cebad1"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
script.render = render

export default script